export default function () {
    // Selecionando Enderecos do estabeleciemnto
  // this.existsRegister('/v1/search/staffs/staff/?limit=false&pagination=false', (data, meta) => {
  //   this.optionsCompanyProfessional = data
  // })

  // this.existsRegister('/v1/search/staffs/speciality/?limit=false&pagination=false&professional_id=' + this.$route.params.professional, (response, meta) => {
  //   const optionsCompanyProfessionalSpecialitiesArray = Object.keys(response).map(i => response[i])
  //   this.optionsCompanyProfessionalSpecialities = optionsCompanyProfessionalSpecialitiesArray
  // })

  this.existsRegister('/v1/search/professionals/professionalSpeciality/?limit=false&pagination=false', (response, meta) => {
    const optionsProfessionalSpecialitiesArray = Object.keys(response).map(i => response[i])
    this.optionsProfessionalSpecialities = optionsProfessionalSpecialitiesArray
  })
  this.doNotAgendaPrivate()
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/form/resources/mounted.js